import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Store } from '@src/store';


// import { SessionService, DialogManagerService } from '@src/services';
import { projectActions } from "../../../../store/reducers/projectReducer";
import { logsActions } from "../../../../store/reducers/logsReducer";
import * as _ from 'lodash';
import moment from 'moment';



@Component({
    selector: 'log-viewer-filter',
    template: require('./log-viewer-filter.component.html'),
    styles: [require('./log-viewer-filter.component.scss')]
})
export class LogFilterComponent implements OnInit, OnDestroy {

    public projects: any;
    public exemple: string = "e.g. my_tabs";
    public unSubscribe: any;
    public today = new Date();
    public blockedReapedtedScheme: boolean = false;
    public fromDate: Date = new Date(this.today.setDate(this.today.getDate() - 30));
    public toDate: Date = new Date();
    public fromTime: any;
    public toTime: any
    public selectedProject: string = "All"
    public selectedEnviroment: string = "All"
    public selectedLevels = []
    public envs = [];
    public waitingForResponse: boolean = false;
    public isGlobal: boolean = false;
    public waitingForResponseSchemas: boolean = false;
    public countRequestForAll: number = 0
    public schemas: any;
    public selectedSchema: string = "All"
    public objectNameFilter: string;
    isCustom: boolean;
    initFrom: boolean;
    initTo: boolean;
    toDateInValid: boolean;

    public levels = [
        { name: "DEBUG", id: 30000 },
        { name: "INFO", id: 40000 },
        { name: "WARNING", id: 60000 },
        { name: "ERROR", id: 70000 },
    ];



    @Output() public filter = new EventEmitter();
    constructor(private store: Store) {
        this.selectedLevels = [
            30000, 40000, 60000, 70000];
    }




    public async ngOnInit() {

        this.unSubscribe = this.store.subscribe(() => {
            if (this.waitingForResponse && this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus) {
                this.store.getState().project.projectEnvTypesWithEnvsAndDeployStatus.forEach(obj => {
                    obj.environments.forEach(env => this.envs.push(env));
                    this.waitingForResponse = false;

                })
                let ids = this.envs.map(obj => obj.id)
                if (ids.length > 0)
                    this.envs = [{
                        'id': ids,
                        'name': 'All',
                        isAll: true
                    }, ...this.envs];
            }

            if (this.waitingForResponseSchemas && this.store.getState().logs.schemas) {
                if (this.countRequestForAll > 0) {
                    this.countRequestForAll--;
                    if (this.countRequestForAll == 0)
                        this.waitingForResponseSchemas = false;
                } else {
                    this.waitingForResponseSchemas = false;
                }
                Object.keys(this.store.getState().logs.schemas).forEach(key => {
                    if (!this.schemas.find(sch => sch.id === key)) {
                        this.schemas.push({
                            'id': key,
                            'name': this.store.getState().logs.schemas[key]
                        })
                    }

                })
                let ids = this.schemas.map(obj => obj.id)
                if (ids.length > 0 && this.schemas.length > 0 && this.schemas[0].isAll == true)
                    this.schemas[0] = {
                        'id': ids,
                        'name': 'All',
                        isAll: true
                    }
                else if (ids.length > 0)
                    this.schemas = [{
                        'id': ids,
                        'name': 'All',
                        isAll: true
                    }, ...this.schemas];

            }

            const projects = this.store.getState().projects.projectItems;
            if (projects && projects.length > 0) {
                this.projects = [{
                    name: "All",
                    id: -1,
                    isAll: true
                }, ...projects];
            }
        });


    }


    setSchemas() {
        this.store.dispatch({ type: logsActions.CLEAR_SCHEMAS_FOR_LOG });
        const ProjectSelected = this.projects.find(x => x.name == this.selectedProject)
        const EnvSelected = this.envs.find(x => x.name == this.selectedEnviroment)
        this.schemas = [];
        this.selectedSchema = null;
        this.countRequestForAll = 0;
        this.waitingForResponseSchemas = true;
        if (EnvSelected.isAll == true) {
            this.countRequestForAll = EnvSelected.id.length;
            EnvSelected.id.forEach(id => {
                this.waitingForResponseSchemas = true;
                this.store.dispatch({
                    type: logsActions.GET_SCHEMAS_FOR_LOG,
                    payload: { projectId: ProjectSelected.id, envId: id }
                });
            })
        } else {
            this.store.dispatch({
                type: logsActions.GET_SCHEMAS_FOR_LOG,
                payload: { projectId: ProjectSelected.id, envId: EnvSelected.id }
            });
        }
    }


    ngOnDestroy() {
        this.envs = null;
        this.schemas = null;
        this.store.dispatch({ type: logsActions.CLEAR_SCHEMAS_FOR_LOG });
        this.unSubscribe();
    }

    



    setEnvs() {
        this.envs = [];
        this.selectedEnviroment = null;
        this.selectedSchema = null;
        const ProjectSelected = this.projects.find(x => x.name == this.selectedProject)
        if (ProjectSelected.id != -1) {
            this.waitingForResponse = true;
            this.store.dispatch({
                type: projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS,
                payload: { projId: ProjectSelected.id }
            });
        }
    }

    selectedTime(data) {
        this.fromDate = new Date(data.value.fromDate);
        this.toDate = new Date(data.value.toDate);

        this.isCustom = (data.name == 'Custom') ? true : false;
        if (this.isCustom) {
            this.initFrom = false;
            this.initTo = false;
        }
    }

    readCookie = (name) => {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) == ' ') c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    }



    inValidToDate(state) {

        if (state == true) {
            this.toDateInValid = true;
            return 'inValidDate';
        }
        this.toDateInValid = false;
        return "";
    }


    public onFilter(): void {

        let projectSelectedObj = !this.projects || this.projects.length === 0 ? null : this.projects.find(x => x.name === this.selectedProject)
        let environmentObj = !this.envs || this.envs.length === 0 ? null : this.envs.find(x => x.name === this.selectedEnviroment)
        let SchemaObj = !this.schemas || this.schemas.length === 0 ? null : this.schemas.find(x => x.name === this.selectedSchema)
        this.fromTime = moment(this.fromDate).format('hh:mm');
        this.toTime = moment(this.toDate).format('hh:mm')


        this.filter.emit({
            data: {
                project: !this.isGlobal ? projectSelectedObj : null,
                fromDate: String(this.fromDate),
                toDate: this.toDate,
                schema: !this.isGlobal ? SchemaObj : null,
                env: !this.isGlobal ? environmentObj : null,
                logLevels: this.selectedLevels,
                toTime: String(this.toTime),
                fromTime: this.fromTime,
                isGlobal: this.isGlobal,
                toTimeType: undefined,
                fromFilter : true,
                fromTimeType: undefined
            }
        });

    }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/log-viewer-ang7/log-viewer-filter/log-viewer-filter.component.ts